import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchContacts() {
  try {
    const contacts = yield call(() => callGetAPI(SERVER_API.CONTACTS));
    yield put({ type: sagaActions.CONTACTS_LOAD, data: contacts.data });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchFetchContactsAsync() {
  yield takeLatest(sagaActions.CONTACTS_LOAD_REQUEST, fetchContacts);
}

export default watchFetchContactsAsync;
